
// 이미지 파일들을 require로 가져오기
export const drumLaunge = require('./drum_launge.jpeg');
export const drumLessonroom = require('./drum_lessonroom.jpeg');
export const drumLessonroom2 = require('./drum_lessonroom2.jpeg');
export const drumPractice = require('./drum_practice.jpeg');
export const drumRestroom = require('./drum_restroom.jpeg');
export const drumRoby = require('./drum_roby.jpeg');
export const drumRoby2 = require('./drum_roby_2.jpeg');
export const drumLogo = require('./drum_logo.png');
export const drumTeacher = require('./drum_teacher.jpeg');

// 아이콘
export const iconNotification = require('./icon-notification.svg').default || require('./icon-notification.svg');